module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10017.1809c884.jpg";